
import React, {Component} from 'react'
import {Box} from 'reactjs-admin-lte'
import {Button,ButtonToolbar,SplitButton,MenuItem,ControlLabel,InputGroup,FormGroup,Row,Col,FormControl} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import DPDocStore from '../../stores/DPDocStore'
import SWTNewCustomerPopup from '../workdoc/SWTNewCustomerPopup'
import DatePicker from '../../component/element/DatePicker'
import AutopartStore from '../../stores/AutopartStore'
import IframeModal from '../../component/element/IframeModal'



var NotificationSystem = require('react-notification-system');

const DEFAULT_ROW = 3
class DepositDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initState()
    
  }

  initState(newState){
    
    let state = {loading:false,showHistory:false,dpNo:'',workNo:'',show:false,shopName:'',rowBeep:-1,data:this.newEmptyRow(DEFAULT_ROW),options:[],doc:this.getEmptyDoc()}

    if(newState!==undefined){
      state = Object.assign(state,newState)
    }
    return state
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillMount() {
    // Instantiate a Realtime client
    
  }

  getNumberFormat(value) {
    if(value===''||value===null||value===undefined||isNaN(value)){
      return ''
    }
    let _val = parseFloat(value)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  renameDoc(newDpNo){
    let {doc} = this.state
    doc['deposit_no'] = newDpNo
    this.setState({dpNo:newDpNo,doc:doc})
  }

  newEmptyRow(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {detail:'',quantity:'',price_per_unit:'',amount:''}
    })
  }

  getEmptyDoc(){
    return {amount:0,customer_name:'',customer_address:'',customer_tel:'',remark:'',status:''}
  }

  loadNewDoc(callback){
    let {loading} = this.state
    
    this.setState(this.initState({loading:true}))
    DPDocStore.newDPDoc((result)=>{            
      let data = this.newEmptyRow(DEFAULT_ROW)
      
      this.setState({loading:false,dpNo:result.data.doc.deposit_no,doc:result.data.doc,data:data})
      if(callback!==undefined){
        callback(result.data.doc)
      }
    })
  }

  loadNewDocFromWork(workNo,item,callback){
    let {loading} = this.state
    
    this.setState(this.initState({loading:true,workNo:workNo}))
    DPDocStore.newDPDocFromWork(workNo,(result)=>{            
      let data = result.data.itemlist.concat(this.newEmptyRow(DEFAULT_ROW))      
      
      this.setState({loading:false,dpNo:result.data.doc.deposit_no,doc:result.data.doc,data:data})
      if(callback!==undefined){
        callback(result.data.doc)
      }
    })
  }

  loadData(dpNo,shouldFocus=true){
    
    this.setState(this.initState({loading:true,dpNo:dpNo}))
    DPDocStore.loadDPDoc(dpNo,(result)=>{
      let data = result.data.itemlist
      if(result.data.itemlist.length<DEFAULT_ROW){
        data = data.concat(this.newEmptyRow(DEFAULT_ROW-result.data.itemlist.length))
      }
      
      this.setState({loading:false,doc:result.data.doc,data:data})
      
      if(shouldFocus){        
       
      }else{
          this._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message:'มีการเปลี่ยนแปลงรายการ',
            level:'info',
            position:'tc'
          });
        }
    })
  }

  onPrintClick(){
    let {dpNo} = this.state
    let url = './pdf/v2?startPage=PrintDepositDoc&dp='+dpNo;
    if (process.env.NODE_ENV == "development") {
        url = '?startPage=PrintDepositDoc&dp='+dpNo;
    }
    this.refs.iframe.getWrappedInstance().loadUrl(url)
  }

  onCustomerClick(){
    this.setState({show:true})
  }

  onInputChange(key,e){
    let {doc} = this.state
    doc[key] = e.target.value
    this.setState({doc:doc})
  }

  onCustomerPageSelect(item){
    let {doc} = this.state
    doc['customer_id'] = item.customer_id
    doc['customer_name'] = item.name
    doc['customer_address'] = item.address
    doc['customer_tel'] = item.tel
    this.setState({doc:doc})
  }

  onDateChange(value){
    let {doc} = this.state
    doc['added_date'] = value
    this.setState({doc:doc})
  }

  onSaveClick(){
    let {doc,data} = this.state
    this.saveDPDoc(doc,data)  
  }

  saveDPDoc(doc,data,completeFunc,failFunc){
    let {loading,dpNo} = this.state
    let that = this
    this.setState({loading:true})
    let postData = {dp:dpNo,doc:doc,itemlist:data}
    if (doc.stock_recordid*1>0) {
      this.setState({loading:false})
      if(completeFunc!==undefined){
        completeFunc()
      }
      return
    }
    DPDocStore.saveDPDoc(postData,function(result){
      doc.seq_no = result.seq_no
      that.setState({loading:false,doc:doc})
      that._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำการบันทึกรายการใบมัดจำเรียบร้อย',
        level:'info',
        position:'tc'
      });
      if(completeFunc!==undefined){
        completeFunc()
      }
        
    },function(error){
      if(failFunc!==undefined){
        failFunc()
      }      
      that._notificationSystem.addNotification({
        title:'แจ้งเตือน',
        message:'ทำการบันทึกรายการล้มเหลว',
        level:'error',
        position:'tc'
      });
      that.setState({loading:false,errorShow:true})
    })
    
  }

  onCloseClick(){
    
    
    if(this.props.onClose!==undefined){
      this.props.onClose()
    }
  }

  onDeleteRowClick(index){
    let {doc,data} = this.state

    data.splice(index,1);  
    this.setState({data:data})    
    
    this.saveDPDoc(doc,data)  
  }

  summaryAmount(data){
    let amount = 0
    data.map((item,index)=>{
      amount += item.amount*1
    })
    return amount
  }

  onFormChange(index,key,e){
    let {doc,data} = this.state
    let value = e.target.value
    data[index][key] = value
    if(['quantity','price_per_unit'].includes(key)){
      data[index]['amount'] = data[index]['quantity']*data[index]['price_per_unit']
      doc['amount'] = this.summaryAmount(data)      
    }
    this.setState({doc:doc,data:data})
  }

  onRowAdd(number){
    let {data} = this.state
    
    
    data = data.concat(this.newEmptyRow(number))

    
    this.setState({data:data})
  }


  onSearch(index,query){
    let that = this
    //let options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
    AutopartStore.loadStockPartItemList(-1,query,function(result){
      
      //options = [{id:1,detail:'test1',amount:2},{id:2,detail:'test2',amount:2}]
      let options = result.data.map((item,index)=>{
        return {id:item.itemnum,productCode:item.productcode,unit:item.unit,quantity:item.quantity,itemnum:item.itemnum,categoryName:item.cat_name,detail:item.description,pricePerUnit:item.price_per_unit}
      })
      that.setState({options:options})
    })
    
    //this.setState({options:options})
  }

 

  onTypeaheadInputChange(index,query){
    let {data} = this.state
    data[index]['detail'] = query
    
    
    this.setState({data:data})
  }

  
  onTextKeyPress(index,key,target) {
    if(target.charCode==13){
      this.onSaveClick()
    }
  }

  onMenuItemSelect(index){
    let {dpNo,doc,data} = this.state
    let that = this
    if('deleteso'===index){   
      this.setState({loading:true})
      DPDocStore.delDPDoc(dpNo,function(result){
        that.setState({loading:false})
        that.onCloseClick()
      })
    }else if("payment"===index){
      let that = this      
      // if (that.onSaveClick()) {
      //   this.setState({loading:true})
      //   let postData = {dp:dpNo,status:'1'}
      //   DPDocStore.updateDPDocStatus(postData,function(result){
      //     doc['status'] = '1'
      //     that.setState({loading:false,doc:doc})
      //   }) 
      // } 

      this.saveDPDoc(doc,data,function(){
        that.setState({loading:true})
        let postData = {dp:dpNo,status:'1'}
        DPDocStore.updateDPDocStatus(postData,function(result){
          doc['status'] = '1'
          that.setState({loading:false,doc:doc})

          that._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message:'ทำการปรับสถานะชำระเงินเรียบร้อย',
            level:'info',
            position:'tc'
          });
        },function(){
          //Status Fail
          that.setState({loading:false})
        }) 
      },function(){
        //Show Error
      })

    }else if("credit"===index){
      let that = this   
      // if (that.onSaveClick()) { 
      //   this.setState({loading:true})
      //   let postData = {dp:dpNo,status:'2'}
      //   DPDocStore.updateDPDocStatus(postData,function(result){
      //     doc['status'] = '2'
      //     that.setState({loading:false,doc:doc})
      //   })  
      // }  
      this.saveDPDoc(doc,data,function(){
        that.setState({loading:true})
        let postData = {dp:dpNo,status:'2'}
        DPDocStore.updateDPDocStatus(postData,function(result){
          doc['status'] = '2'
          that.setState({loading:false,doc:doc})

          that._notificationSystem.addNotification({
            title:'แจ้งเตือน',
            message:'ทำการปรับสถานะขอเครดิตเรียบร้อย',
            level:'info',
            position:'tc'
          });
        },function(){
          //Status Fail
          that.setState({loading:false})
        }) 
      },function(){
        //Show Error
      })  
    }else if("receipt"===index){
      this.setState({showHistory:true})
      this.refs.saleHist.loadData(index,'ใบเสร็จรับเงิน',dpNo)
    }else if("taxinvoice"===index){
      this.setState({showHistory:true})
      this.refs.saleHist.loadData(index,'ใบกำกับภาษี',dpNo)
    }else if("cashbill"===index){
      this.setState({showHistory:true})
      this.refs.saleHist.loadData(index,'บิลเงินสด',dpNo)
    }
  }

  getValidationState() {
    const length = this.state.shopName.length;
    if (length > 10) return 'success';
    else if (length > 5) return 'warning';
    else if (length > 0) return 'error';
  }

  _renderMenuItemChildren(option, props, index) {
    let quantityTitle = ''
    if(option.quantity>0){
      quantityTitle = ' มีจำนวน '+option.quantity+' '+option.unit
    }

    if(option.pricePerUnit>0){
      return (
        <div key={option.id}>               
          <span>{option.detail} (หมวด{option.categoryName}) - {option.pricePerUnit} บาท {quantityTitle}</span>
        </div>
      );
    }else{
      return (
        <div key={option.id}>               
          <span>{option.detail} {quantityTitle}</span>
        </div>
      );
    }
  }

  renderHeaderRow(){
    let {work_no,customer_name,customer_address,added_date,customer_tel,car_info} = this.state.doc

    return (
      <div>           
        <Row>
        <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>ชื่อลูกค้า :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='user'/></InputGroup.Addon>
                <FormControl value={customer_name} onChange={this.onInputChange.bind(this,'customer_name')}/>
                <InputGroup.Addon onClick={this.onCustomerClick.bind(this)}><FontAwesome name='plus'/></InputGroup.Addon>
              </InputGroup>            
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel>ที่อยู่ :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='location-arrow'/></InputGroup.Addon>
                <FormControl value={customer_address} onChange={this.onInputChange.bind(this,'address')} />
              </InputGroup>            
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel>เบอร์โทร :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='phone'/></InputGroup.Addon>
                <FormControl value={customer_tel} onChange={this.onInputChange.bind(this,'tel')} />
              </InputGroup>            
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel>หมายเลขรับแจ้ง/ใบงาน :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='file'/></InputGroup.Addon>
                <FormControl value={work_no} disabled={true}/>
              </InputGroup>   
              <div>
                สถานะ <span className="label label-default">เริ่มต้น</span>
              </div>         
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup
              controlId="formBasicText"
              validationState={null}
            >
              <ControlLabel>ข้อมูลรถยนต์ :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='car'/></InputGroup.Addon>
                <FormControl value={car_info} disabled={true}/>
              </InputGroup>       
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId="formBasicText"
              validationState={this.getValidationState()}
            >
              <ControlLabel>วันที่ :</ControlLabel>
              <InputGroup>
                <InputGroup.Addon><FontAwesome name='calendar'/></InputGroup.Addon>              
                <DatePicker style={{display:'inline-block'}}
                  showIcon={false}
                  showFooter={true}
                  popPlacement='bottom'
                  buddhistEra
                  value={added_date} 
                  onChange={this.onDateChange.bind(this)}/>
              </InputGroup>            
            </FormGroup>
          </Col>
        </Row>
      </div>  
    )
  }


  renderRemark(){
    let {remark} = this.state.doc
    return (
      <Row>
      <Col md={3}>
        <FormGroup
          controlId="formBasicText"
          validationState={this.getValidationState()}
        >
          <ControlLabel>หมายเหตุ </ControlLabel>
          <InputGroup>            
            <FormControl value={remark} componentClass="textarea" style={{width:'400px',height:'150px'}}
             onChange={this.onInputChange.bind(this,'remark')}/>            
          </InputGroup>            
        </FormGroup>
      </Col>
      </Row>
    )
  }

  getRowClassName(item,index){
    let {rowBeep} = this.state
    let className = (item.itemnum>0)?'':(item.detail.length>0)?'bg-gray':''

    if(rowBeep===index){
      className = 'bg-yellow'      
    }
    return className
  }

  renderRowData(){
    let {data,options} = this.state
    return data.map((item,index)=>(
      <tr key={index} className={this.getRowClassName(item,index)}>
        <td className='text-center'>{index+1}</td>
        <td className='data-column'>
          <FormControl className='text-left'           
          value={item.detail} 
          onChange={this.onFormChange.bind(this,index,'detail')}          
          />          
        </td>                
        <td  className='data-column text-center'><FormControl className='text-center' 
        value={item.quantity} 
        onChange={this.onFormChange.bind(this,index,'quantity')}
        onKeyPress={this.onTextKeyPress.bind(this,index,'quantity')}
        /></td>
        <td className='data-column text-right'><FormControl className='text-right' 
        value={item.price_per_unit} 
        onChange={this.onFormChange.bind(this,index,'price_per_unit')}
        onKeyPress={this.onTextKeyPress.bind(this,index,'price_per_unit')}
        /></td>
        <td className='data-column text-right'>{item.amount}</td>
        <td className='text-center'><Button bsStyle={'danger'} onClick={this.onDeleteRowClick.bind(this,index)}><FontAwesome name='trash'/></Button></td>
      </tr>
    ))

  }

  onDepositAmountChange(e) {
    let {doc} = this.state
    doc.deposit_amount = e.target.value
    this.setState({doc:doc})
  }

  getBalance(amount,deposit_amount) {
    let sum = 0
    if (amount===''||amount===null||amount===undefined||isNaN(amount))
      amount = 0

    if (deposit_amount===''||deposit_amount===null||deposit_amount===undefined||isNaN(deposit_amount))
      deposit_amount = 0

    sum = amount - deposit_amount
    return sum
  }

  renderTable(){
    let {doc} = this.state
    return (
      <table className='table table-responsive table-hover table-bordered-solid'>
        <thead>
          <tr >
            <th className='text-center' style={{width:'30px'}}>ลำดับ</th>            
            <th>รายการ</th>            
            <th className='text-center' style={{width:'70px'}}>จำนวน</th>
            <th className='text-center' style={{width:'120px'}}>ราคาหน่วยละ</th>
            <th className='text-center' style={{width:'120px'}}>จำนวนเงิน</th>
            <th className='text-center' style={{width:'30px'}}>ลบ</th>
          </tr>
        </thead>
        <tbody>
          {this.renderRowData()}
        </tbody>
        <tfoot>
          <tr>            
            <th colSpan={4} className='text-right'>รวมเป็นเงิน</th>
            <th className='text-right'>{this.getNumberFormat(doc.amount)}</th>
            <th className='text-right'></th>
          </tr>
          <tr>            
            <th colSpan={4} className='text-right'>มัดจำ</th>
            <th className='text-right'><FormControl value={doc.deposit_amount} className='text-right' onChange={this.onDepositAmountChange.bind(this)} /></th>
            <th className='text-right'></th>
          </tr>
          <tr>            
            <th colSpan={4} className='text-right'>คงเหลือ</th>
            <th className='text-right'>{this.getNumberFormat(this.getBalance(doc.amount,doc.deposit_amount))}</th>
            <th className='text-right'></th>
          </tr>
        </tfoot>
      </table>
    )
  }

  renderNewItemButton(){
    return (
      <div style={{display:'inline-flex'}}>
        <ButtonToolbar>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,1)}><FontAwesome name='plus'/>&nbsp;เพิ่มรายการ</Button>
          <Button className='bg-olive' onClick={this.onRowAdd.bind(this,10)}><FontAwesome name='plus'/>&nbsp;เพิ่ม 10 รายการ</Button>
        </ButtonToolbar>        
      </div>
    )
  }

  renderDocMenu(){
    let title = (<span><i className="fa  fa-edit"></i>&nbsp;สร้างเอกสาร</span>)
    return (
      
        
          <SplitButton bsStyle={'primary'} title={title}  onSelect={this.onMenuItemSelect.bind(this)}>
            <MenuItem eventKey="receipt"><FontAwesome name='file-text-o' className='text-green'/>ใบเสร็จรับเงิน</MenuItem>
            <MenuItem eventKey="taxinvoice"><FontAwesome name='file-text-o' className='text-green'/>ใบกำกับภาษี</MenuItem>
            <MenuItem eventKey="cashbill"><FontAwesome name='file-text-o' className='text-green'/>บิลเงินสด</MenuItem>
          </SplitButton>
        
      
    )
  }

  renderStatus(){
    let {doc} = this.state
    if(doc.status==='1'){
      return (<span className='label label-success'>ชำระเงินแล้ว</span>)
    }else  if(doc.status==='2'){
      return (<span className='label label-primary'>ขอเครดิต</span>)
    }else{
      return (<span/>)
    }

  }

  renderStockStatus(){
    let {doc} = this.state
    if(doc.stock_recordid*1>0){
      return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
    }else{
      return (<span/>)
    }
  }

  render(){
    let {loading,show,doc,showHistory,dpNo} = this.state
    let title = (<span><i className="fa  fa-check-square-o"></i>&nbsp;สถานะ</span>)
    let showSave = true
    return (
      <Box loading={loading}>
        <Box.Header  className='text-center'>
          <Box.Title>
            {'ใบมัดจำเลขที่ '+dpNo} 
          </Box.Title>
          <Box.Tools className='pull-right' >
            <Button className='bg-maroon'                       
              	onClick={this.onPrintClick.bind(this)}
              >
               	<FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
              </Button>  
                               
          </Box.Tools> 
        </Box.Header>
        <Box.Body>
          {this.renderHeaderRow()}
          {this.renderTable()}
          {this.renderNewItemButton()}
          {this.renderRemark()}
          <SWTNewCustomerPopup show={show} onHide={()=>{this.setState({show:false})}}
            onSelect={this.onCustomerPageSelect.bind(this)}
            />
          
          <NotificationSystem ref="notificationSystem" />  
          <IframeModal ref='iframe'  title={'พิมพ์เอกสาร'} /> 
        </Box.Body>
        <Box.Footer>
          <ButtonToolbar className='pull-right'>
            <Button style={{display:showSave?'block':'none'}} bsStyle='primary' onClick={this.onSaveClick.bind(this)}><FontAwesome name='save' />&nbsp;บันทึก</Button>
            <Button onClick={this.onCloseClick.bind(this)}><FontAwesome name='close' />&nbsp;ปิดเอกสาร</Button>
          </ButtonToolbar>
        </Box.Footer>
      </Box>
    )
  }
}


export default DepositDoc;





// WEBPACK FOOTER //
// ./src/view/so/DepositDoc.js